/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Modal, Button } from '@atoms';
import { TextField } from '@molecules';
import Form from '@organisms/Form';

import { FORM_FIELD, SHORTCODE_LABEL } from './constants';
import { useShortcodes } from './hooks';
import s from './styles.module.less';

const ShortcodeModal = ({
  okText = 'ADD URL',
  cancelText = 'CANCEL',
  hide,
  type: shortcode,
  onSubmit,
  onCancel = hide,
  ...props
}) => {
  const [form] = Form.useForm();

  const handleOk = async (values) => {
    onSubmit(`[${shortcode}=${values[FORM_FIELD.URL.name]}]`);
    form.resetFields();
    hide();
  };

  const footer = (
    <>
      <Button key="submit" type="customBlue" onClick={form.submit}>
        {okText}
      </Button>

      <Button key="back" onClick={onCancel}>
        {cancelText}
      </Button>
    </>
  );

  return (
    <Modal footerDivider={false} footer={footer} title={null} className={s.custom} {...props}>
      <Form wrapperCol={{ span: 24 }} form={form} layout="vertical" onFinish={handleOk}>
        <TextField
          {...FORM_FIELD.URL}
          label={SHORTCODE_LABEL[shortcode]}
          placeholder={`https://${shortcode}.url`}
          className={s.formItem}
        />
      </Form>
    </Modal>
  );
};

ShortcodeModal.useShortcodes = useShortcodes;

export default ShortcodeModal;
